import { BankOperationStatusChipField } from 'pages/Finance/RequestsBankOps/components/BankOperationStatusChipField/BankOperationStatusChipField';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { BankOperationComment } from 'types/embedded/bankOperation';

import { AvatarWrapperStyled, BoxStyled } from './RequestsBankOpsShowComment.styled';
import { RequestsBankOpsShowCommentUser } from './RequestsBankOpsShowCommentUser/RequestsBankOpsShowCommentUser';

export const RequestsBankOpsShowComment: React.FC = () => {
  const record = useRecordContext<BankOperationComment>();

  if (!record) {
    return <></>;
  }

  return (
    <BoxStyled>
      <AvatarWrapperStyled>
        <RecordContextProvider value={record?.user}>
          <RequestsBankOpsShowCommentUser createdAt={record?.createdAt} />
        </RecordContextProvider>
        <RecordContextProvider value={record.status}>
          <BankOperationStatusChipField source="description" />
        </RecordContextProvider>
      </AvatarWrapperStyled>
      <Box sx={{ overflowX: 'auto' }}>
        <Typography>{record?.commentText}</Typography>
      </Box>
    </BoxStyled>
  );
};
